import { setUrlToDataSource } from '@/tools/setUrlToDataSource';

// Load JSON data from atribute data-media
export function loadMediaObjects($el, dataSourceURL) {
	const cleardMessage = '... cleared, if you dont like it search this text and revert.';
	const mediaArrayString = $el ? $el.dataset.media || '[]' : '[]';
	if (mediaArrayString == cleardMessage) return [];
	const mediaArray = JSON.parse(mediaArrayString);
	// Clear data attribute since it's bad for debugging the DOM
	if (mediaArray.length) {
		$el.dataset.media = cleardMessage;
	}
	// Set pathes of mediaFiles to datasource
	mediaArray.forEach(entry => {
		const mediaObject = entry[1];
		['Sources', 'BigSources', 'ThumbSources', 'threeDMaterial'].forEach(urlProp => {
			if (mediaObject[urlProp])
				Object.entries(mediaObject[urlProp]).forEach(([key, value]) => {
					mediaObject[urlProp][key] = setUrlToDataSource(value, dataSourceURL);
				});
		});

		if (mediaObject.threeDTextures) {
			mediaObject.threeDTextures = Object.entries(mediaObject.threeDTextures).reduce((acc, [lang, list]) => {
				acc[lang] = list.map(value => setUrlToDataSource(value, dataSourceURL));
				return acc;
			}, {});
		}
		if (mediaObject.threeDResourceMap) {
			// fix resourceMap keys
			mediaObject.threeDResourceMap = Object.entries(mediaObject.threeDResourceMap).reduce(
				(acc, [lang, map]) => {
					acc[lang] = Object.entries(map).reduce((newMap, [key]) => {
						const newKey = setUrlToDataSource(key, dataSourceURL);
						newMap[newKey] = map[key];
						return newMap;
					}, {});
					return acc;
				},
				{}
			);
		}
	});

	return mediaArray;
}
